module.exports = {
        srcSet: __webpack_public_path__ + "lube_products_rotella-160-a46432d423edecb4.digested.png"+" 160w",
        images: [{path: __webpack_public_path__ + "lube_products_rotella-160-a46432d423edecb4.digested.png",width: 160,height: 160}],
        src: __webpack_public_path__ + "lube_products_rotella-160-a46432d423edecb4.digested.png",
        toString: function(){return __webpack_public_path__ + "lube_products_rotella-160-a46432d423edecb4.digested.png"},
        
        width: 160,
        height: 160
      }